import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SEOHead from '../SEOHead';
import DesktopNavigation from '../Navigation/DesktopNavigation';
import MobileNavigation from '../Navigation/MobileNavigation';
import Footer from '../Footer/Footer';

const CopyrightNoticePage: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans overflow-x-hidden selection:bg-[#05a5b7] selection:text-white flex flex-col">
      <SEOHead 
        title={`${t('copyrightNoticePage.title')} | Christ Reigns Media`}
        description={t('copyrightNoticePage.intro')}
      />
      
      <DesktopNavigation />
      <MobileNavigation />
      
      <main className="flex-grow pt-24 xl:pt-32 pb-20">
        <div className="container mx-auto px-6 md:px-8 max-w-4xl">
          
          {/* Header */}
          <div className="border-b border-gray-200 pb-8 mb-12">
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-4">
              {t('copyrightNoticePage.title')}
            </h1>
            <p className="text-sm text-[#05a5b7] font-bold uppercase tracking-wider font-mono">
              {t('copyrightNoticePage.allRightsReserved')}
            </p>
          </div>

          {/* Intro Paragraph */}
          <p className="text-lg text-gray-700 leading-relaxed mb-10 font-light">
            {t('copyrightNoticePage.intro')}
          </p>

          {/* Detailed Notice Sections */}
          <div className="space-y-8 text-gray-700 leading-relaxed">
            <p>{t('copyrightNoticePage.section1')}</p>
            <p>{t('copyrightNoticePage.section2')}</p>
            <p>{t('copyrightNoticePage.section3')}</p>
            <p>{t('copyrightNoticePage.section4')}</p>
            <p>{t('copyrightNoticePage.section5')}</p>
          </div>

        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default CopyrightNoticePage;
